<div>
    <div class="count-header">
        <div class="count-header-item">
            <div class="title">{{ header().title }}</div>
            <div class="subtitle">{{ header().subtitle }}</div>
        </div>
        <div class="count-header-item eyeball">
            <button
                class="button-eyeball"
                id="testerThing"
                mat-icon-button
                (click)="viewDetails.emit()"
                matTooltip="View Details"
                aria-label="View Details"
                type="button">
                <fa-icon icon="eye" />
            </button>
        </div>
    </div>
    <div class="dashboard-count">{{ count().value }}</div>
</div>
